export default __webpack_public_path__ + "static/media/cavax.44b4f932.png";